import { message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    ModalItem,
    FormItem,
    ButtonItem,
    ErrorItem,
    DatePickerItem,
    SelectTurnosItem,
    SelectEmpleadosItem
} from "../../../../Components/Items";

class AgregarAsignacionTurno extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
    };
    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible)
            this.consultarTodo();
    }
    cerrarAgregarAsignacionTurno(codigo) {
        this.props.cerrarAgregarAsignacionTurno(codigo);
    }
    async consultarTodo() {
        this.setState({ loading: true });
        this.setState({ loading: false });
    }
    onFinishFailed(e) {
        ErrorItem(e);
    }
    onFinish(values) {
        this.setState({ loading: true });
        axios
            .post(
                "asignacionesTurnos/agregarAsignacionTurno",
                { ...values, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se ha registrado una asignación de turno");
                    this.formRef.current.resetFields();
                    this.cerrarAgregarAsignacionTurno(res.data.codigo);
                } else if (res.data.success === 1) {
                    message.error("No se puede registrar la asignación de turno");
                } else {
                    message.error("Hubo un error y la asignación de turno no se registro");
                }
            });
    }
    render() {
        return (
            <>
                <ModalItem
                    title="Agregar Asignación de Turno"
                    visible={this.props.visible}
                    spinning={this.state.loading}
                    onCancel={this.cerrarAgregarAsignacionTurno.bind(this)}
                    paddingTop
                >
                    <Form
                        ref={this.formRef}
                        name="agregarAsignacionTurno"
                        layout
                        bottom={
                            <ButtonItem
                                type="primary"
                                htmlType="submit"
                                style={{ display: "block", margin: "0 0 0 auto" }}
                            >
                                Agregar
                            </ButtonItem>
                        }
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <FormItem
                            label="Inicio"
                            name="inicio"
                            required
                            margin
                        >
                            <DatePickerItem
                                placeholder="Fecha de Inicio"
                                allowClear={false}
                            />
                        </FormItem>
                        <FormItem
                            label="Fin"
                            name="fin"
                            required
                            margin
                        >
                            <DatePickerItem
                                placeholder="Fecha de Fin"
                                allowClear={false}
                            />
                        </FormItem>
                        <FormItem
                            label="Turno"
                            name="turnoId"
                            fieldKey="turnoId"
                            margin
                            required
                        >
                            <SelectTurnosItem
                                empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                headersToken={this.props.headersToken}
                                sinBorde
                                autoFocus
                                dropdownMatchSelectWidth={600}
                                width="100%"
                                placeholder="Turno"
                            />
                        </FormItem>
                        <FormItem
                            label="Empleado"
                            name="empleadoId"
                            fieldKey="empleadoId"
                            margin
                            required
                        >
                            <SelectEmpleadosItem
                                empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                headersToken={this.props.headersToken}
                                sinBorde
                                autoFocus
                                dropdownMatchSelectWidth={600}
                                width="100%"
                                placeholder="Empleados"
                            />
                        </FormItem>
                    </Form>
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(AgregarAsignacionTurno);
